import { formatMoney } from '@helpers/global';
import { Cost } from '@interfaces/cart';
import React, { useMemo } from 'react';

const CartItemPrice: React.FC<{ cost: Cost; isCartPage: boolean; isGwp: boolean }> = ({
  cost,
  isCartPage,
  isGwp,
}) => {
  const formattedPrice = useMemo(() => {
    const compareAt =
      cost.compareAtAmountPerQuantity?.amount &&
      parseFloat(cost.compareAtAmountPerQuantity.amount) > 0
        ? formatMoney({
            amount: cost.compareAtAmountPerQuantity.amount,
            currencyCode: cost.compareAtAmountPerQuantity.currencyCode || '',
          }) || ''
        : null;

    const total =
      cost.totalAmount?.amount && parseFloat(cost.totalAmount.amount) > 0
        ? formatMoney({
            amount: cost.totalAmount.amount,
            currencyCode: cost.totalAmount.currencyCode || '',
          }) || ''
        : null;

    return { compareAt, total };
  }, [cost]);

  const showCompareAt =
    cost.compareAtAmountPerQuantity?.amount &&
    parseFloat(cost.compareAtAmountPerQuantity.amount) > parseFloat(cost.totalAmount.amount);

  return (
    <div className={`flex gap-2 items-center ${isCartPage ? 'md:flex-col md:gap-0' : ''}`}>
      {/* GWP Products */}
      {isGwp && (
        <div className="flex items-center gap-1">
          {/* Show compareAt price if available, otherwise show the regular price */}
          <p className="util line-through decoration-1 text-grey-8 font-bold">
            {formattedPrice.compareAt || formattedPrice.total}
          </p>
          <span className="text-black font-bold">{window.DEPT.Strings.cart.freeGift}</span>
        </div>
      )}

      {/* Non-GWP Products */}
      {!isGwp && (
        <div className="flex items-center gap-2">
          {/* Show compareAt price if available */}
          {showCompareAt && (
            <p className="util line-through decoration-1 text-grey-8 font-bold">
              {formattedPrice.compareAt}
            </p>
          )}
          {/* Show regular price */}
          <p className="util text-black font-bold">{formattedPrice.total}</p>
        </div>
      )}
    </div>
  );
};

export default CartItemPrice;
